import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  embedded: { gap: rh(32), paddingTop: rh(40) },
  container: {
    backgroundColor: theme.COLOR_BG_BASE,
    gap: rh(40),
    paddingBottom: rh(24),
    paddingHorizontal: rw(24),
    paddingTop: rh(64),
  },
  close: { position: 'absolute', right: rw(20), top: rh(20), zIndex: 1 },
  content: { alignItems: 'center', gap: rh(32) },
  titleBlock: { alignItems: 'center', gap: rh(12) },
  title: {
    color: theme.COLOR_TEXT_PRIMARY,
    fontSize: rf(28),
    letterSpacing: rw(-0.56),
    lineHeight: rh(33.6),
    textAlign: 'center',
  },
  description: {
    color: theme.COLOR_TEXT_SECONDARY,
    fontSize: rf(16),
    lineHeight: rh(22),
    maxWidth: rw(345),
    textAlign: 'center',
  },
  features: { alignItems: 'center', gap: rh(16) },
  featureRow: { alignItems: 'center', flexDirection: 'row', gap: rw(8) },
  featureTextRow: { alignItems: 'center', flexDirection: 'row', gap: rw(4) },
  featureText: { color: theme.COLOR_TEXT_PRIMARY, fontSize: rf(14), lineHeight: rh(20) },
  platinumRate: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    overflow: 'hidden',
    gap: rw(5),
    borderRadius: rw(8),
    paddingHorizontal: rw(8),
    paddingVertical: rh(2),
  },
  platinumRateValue: {
    color: theme.COLOR_NEUTRAL_50,
    fontSize: rf(14),
    lineHeight: rf(18.2),
    includeFontPadding: false,
    textAlign: 'center',
    textAlignVertical: 'center',
    flexShrink: 0,
  },
  platinumRateBackground: { position: 'absolute', inset: 0 },
  regularRateValue: {
    color: theme.COLOR_TEXT_DISABLED,
    fontSize: rf(13),
    lineHeight: rf(18.2),
    includeFontPadding: false,
    textAlign: 'center',
    textAlignVertical: 'center',
    flexShrink: 0,
    textDecorationLine: 'line-through',
  },
  rateValue: { color: theme.COLOR_TEXT_BRAND, fontSize: rf(14), lineHeight: rh(20) },
  payIcons: { alignItems: 'center', flexDirection: 'row', gap: rw(4) },
}))
